export default __webpack_public_path__ + "static/orange flower-868de7161c2f554dfa4f851789b3916b.png";